import { findEntryByTileId } from '../utils/navigation-launchpad-utils';
import { useNavigationEntries } from './use-navigation-entries';
import { leagueIdFromTile, useSbkLobbySectionSelection } from './use-sbk-lobby-section-selection';

export const useSelectedNavigationEntry = () => {
    const { data: entries } = useNavigationEntries();
    const selectedTile = useSbkLobbySectionSelection(state => state.selectedTile);
    const selectedSubGroupId = useSbkLobbySectionSelection(state => state.selectedSubGroupId);
    const setSelectedSubGroup = useSbkLobbySectionSelection(state => state.actions.setSelectedSubGroup);

    const entry = entries ? findEntryByTileId(entries, selectedTile) : undefined;
    const subGroups = entry?.sub_groups.filter(subGroup => subGroup.type === 'league') ?? [];
    const selectedSubGroup = subGroups.find(subGroup => subGroup.id === selectedSubGroupId) ?? subGroups[0];

    return {
        selectedTile,
        hasEntry: !!entry,
        subGroups,
        selectedSubGroupId: selectedSubGroup?.id,
        selectedLeagueId: leagueIdFromTile(selectedTile) ?? selectedSubGroup?.league_id,
        setSelectedSubGroup,
    };
};
